import { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelf, selectIsAuthenticated } from "@/store/slices/authSlice";
import { AppDispatch } from "@/store";

/**
 * AuthInitializer component
 *
 * This component is responsible for calling the getSelf API when the application
 * initializes. It will update the Redux state with the latest user data when the
 * page refreshes or when the user returns after closing a tab.
 */
const AuthInitializer: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const initializationDone = useRef(false);

  useEffect(() => {
    // Only call getSelf if the user is authenticated and it hasn't been called yet
    if (isAuthenticated && !initializationDone.current) {
      initializationDone.current = true;
      dispatch(getSelf());
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default AuthInitializer;
